import * as THREE from 'three';
import { ThreeDObject } from '../interfaces/ThreeDObject';

// Concrete implementation of icosahedron (Strategy Pattern)
export class Icosahedron extends ThreeDObject {
    private mesh: THREE.Mesh;
    private material: THREE.MeshLambertMaterial;
    private geometry: THREE.IcosahedronGeometry;

    constructor() {
        super();
        this.geometry = new THREE.IcosahedronGeometry(1.35, 0);
        this.material = new THREE.MeshLambertMaterial({
            color: 0xffffff,
            transparent: false,
            opacity: 1.0
        });
        this.mesh = new THREE.Mesh(this.geometry, this.material);
    }

    create(): THREE.Object3D {
        return this.mesh;
    }

    animate(time: number): void {
        if (this.mesh) {
            this.mesh.rotation.x = time * 0.0001;
            this.mesh.rotation.y = time * 0.0001;
            this.mesh.rotation.z = time * 0.0001;
        }
    }

    getMesh(): THREE.Mesh {
        return this.mesh;
    }
}
